export const ANALYTIC_PERIODS = Object.freeze([
  {
    label: "Today",
    value: "today",
    period: "hourly",
  },
  {
    label: "This Week",
    value: "thisWeek",
    period: "daily",
  },
  {
    label: "This Month",
    value: "thisMonth",
    period: "daily",
  },
  {
    label: "Yesterday",
    value: "yesterday",
    period: "hourly",
  },
  {
    label: "Previous Week",
    value: "previousWeek",
    period: "daily",
  },
  {
    label: "Previous Month",
    value: "previousMonth",
    period: "daily",
  },
])
